module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_vehicle_add_to_comp_hover.ccc64eba.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_vehicle_add_to_comp_hover.png
// module id = 1009
// module chunks = 16